import { NgModule,CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

import { SolutionComponent } from '../comp/solution/solution.component';
import { ContentComponent } from '../comp/content/content.component';
import { CodepythonComponent } from '../comp/codepython/codepython.component';
import { VideoComponent } from '../comp/video/video.component';
import { UrlhtmlComponent } from '../comp/urlhtml/urlhtml.component';
import { QuizComponent } from '../comp/quiz/quiz.component';
import { RadioComponent } from '../comp/radio/radio.component';
import { ChekboxComponent } from '../comp/chekbox/chekbox.component';
import { QuestexteComponent } from '../comp/questexte/questexte.component';
import { BtsuivantComponent } from '../comp/btsuivant/btsuivant.component';
import { PrintcodeComponent } from '../comp/printcode/printcode.component';
import { PrintquizComponent } from '../comp/printquiz/printquiz.component';
import { PrintradioComponent } from '../comp/printradio/printradio.component';
import { QuesrtexteComponent } from '../comp/quesrtexte/quesrtexte.component';
import { EditquizComponent } from '../comp/editquiz/editquiz.component';
import { EditradioComponent } from '../comp/editradio/editradio.component';
import { EditsolutionComponent } from '../comp/editsolution/editsolution.component';
import { EdittextComponent } from '../comp/edittext/edittext.component';
import { EditableComponent } from '../comp/editable/editable.component';
import { TextinputComponent } from '../comp/textinput/textinput.component';
import { LoginComponent } from '../comp/login/login.component';
import { HtmlcssjsComponent } from '../comp/htmlcssjs/htmlcssjs.component';
import { Htmlcss2Component } from '../comp/htmlcss2/htmlcss2.component';
import { Htmlcss2printComponent } from '../comp/htmlcss2print/htmlcss2print.component';
import { HtmlcssprintComponent } from '../comp/htmlcssprint/htmlcssprint.component';
import { DateComponent } from '../comp/date/date.component';
import { RvbComponent } from '../comp/rvb/rvb.component';
import { ChronoComponent } from '../comp/chrono/chrono.component';
import { DrawingComponent } from '../comp/drawing/drawing.component';
import { CorrectconnexionComponent } from '../comp/correctconnexion/correctconnexion.component';



const PAGES_COMPONENTS = [
  SolutionComponent,
  CorrectconnexionComponent,
  VideoComponent,
  DrawingComponent,
  UrlhtmlComponent,
  QuizComponent,
  ChronoComponent,
  ChekboxComponent,
  RadioComponent,
  Htmlcss2Component,
  Htmlcss2printComponent,
  BtsuivantComponent,
  QuestexteComponent,
  PrintradioComponent,
  EditquizComponent,
  EditradioComponent,
  HtmlcssprintComponent,
  TextinputComponent,
  EdittextComponent,
  EditsolutionComponent,
  CodepythonComponent,
  EditableComponent,
  PrintcodeComponent,
  PrintquizComponent,
  DateComponent,
  QuesrtexteComponent,
  LoginComponent,
  RvbComponent,
  HtmlcssjsComponent,
  ContentComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule.forRoot(),
  ],
  declarations: [
    PAGES_COMPONENTS
  ],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
  exports: [
    PAGES_COMPONENTS
  ],
  entryComponents: [],
})
export class ComponentsModule {}